import { ProLightCheck } from '@nexelem/icons/ProLightCheck';
import { ProLightXmark } from '@nexelem/icons/ProLightXmark';
import { IconButton } from '@nexelem/components';
import { ReactNode } from 'react';
import { SingleDetailLabel } from './SingleDetailLabel';
import clsx from 'clsx';

type SingleDetailEditableProps = {
  title: ReactNode;
  children: ReactNode;
  onCancel: () => void;
  isPending?: boolean;
};

export const SingleDetailEditable = ({ title, onCancel, children, isPending }: SingleDetailEditableProps) => (
  <div className="relative flex flex-col gap-5 rounded-xs border border-border-container bg-surface-container-lighter px-2 py-4">
    <SingleDetailLabel>{title}</SingleDetailLabel>
    <div className="absolute top-2 right-2 flex gap-1">
      <IconButton Icon={ProLightXmark} size="small" onClick={onCancel} />
      <IconButton
        className={clsx(isPending && 'animate-spin')}
        Icon={ProLightCheck}
        isLoading={isPending}
        size="small"
        type="submit"
      />
    </div>
    <div className="px-2 py-1">{children}</div>
  </div>
);
